import { Box, Button, makeStyles } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { RootState, useSelector } from 'src/store';
import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';
import { editBtnAgain, editBtnText } from 'src/store/modules/buttons';
import { editTracking } from 'src/store/modules/trackings';

const useStyles = makeStyles(() => ({
  wrapper: {
    padding: '1.5rem 1rem 0 1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    backgroundColor: '#fff'
  },
  editor: {
    // margin: 'auto',
    display: 'flex',
    justifyContent: 'space-between'
  },
  title: {
    color: '#000',
    textAlign: 'center',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: 'normal',
    letterSpacing: '0.0175rem'
  },
  scrollNumber: {
    margin: 'auto',
    overflowX: 'auto',
    display: 'flex',
    gap: '0.5rem'
  },

  numberBox: {
    maxWidth: '2rem',
    minWidth: '2rem',
    maxHeight: '2rem',
    minHeight: '2rem',

    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontWeight: 400,

    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    backgroundColor: '#E0E0E0'
  },

  addSubtract: {
    width: '100%',
    height: '2.5rem',
    padding: '0.5rem',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: '#434343'
  },
  btnMinusPlus: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem',
    padding: 0,
    display: 'flex'
  },
  text: {
    color: '#fff',
    textAlign: 'center',
    fontFamily: 'Archivo',
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 600,
    letterSpacing: '0.0175rem'
  },
  slideRight: {
    color: '#828282',
    textAlign: 'right',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal'
  }
}));

const EditMultiOption = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  let tracking = useSelector((state: RootState) => state.trackings.tracking);

  let datas = btnText?.multi_action_survey?.[currentIndex]?.length;

  const handleDatas = (tf: boolean) => {
    let newBtnText = JSON.parse(JSON.stringify(btnText));
    let newTracking = JSON.parse(JSON.stringify(tracking));
    const btnText_len = newBtnText['multi_action_survey'][currentIndex].length;
    const tracking_len =
      newTracking['multi_action_survey'][currentIndex].length;
    if (tf) {
      newBtnText['multi_action_survey'][currentIndex][btnText_len] =
        newBtnText['multi_action_survey'][currentIndex][btnText_len - 1];
      newTracking['multi_action_survey'][currentIndex][
        tracking_len
      ] = `option ${currentIndex + 1}-${tracking_len + 1}`;
    } else {
      newBtnText['multi_action_survey'][currentIndex].pop();
      newTracking['multi_action_survey'][currentIndex].pop();
    }
    dispatch(editBtnText(newBtnText));
    dispatch(editTracking(newTracking));

    let newBtnAgain = JSON.parse(JSON.stringify(btnAgain));
    const btnAgain_len =
      newBtnAgain?.['multi_action_survey']?.[currentIndex]?.length;
    newBtnAgain['multi_action_survey'][currentIndex][btnAgain_len] =
      newBtnAgain?.['multi_action_survey']?.[currentIndex]?.[btnAgain_len - 1];
    dispatch(editBtnAgain(newBtnAgain));
  };

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.addSubtract}>
        <Button
          className={classes.btnMinusPlus}
          disabled={datas === 2}
          onClick={() => handleDatas(false)}
        >
          <Minus stroke="#fff" />
        </Button>
        <span className={classes.text}>OPTION</span>
        <Button
          className={classes.btnMinusPlus}
          disabled={datas === 5}
          onClick={() => handleDatas(true)}
        >
          <Plus stroke="#fff" />
        </Button>
      </Box>
      <span className={classes.slideRight}>
        Choose from 2 to 5 question options
      </span>
    </Box>
  );
};

export default EditMultiOption;
